export type MediaType = "movie" | "tv";

export interface CastMember {
  name: string;
  role: string;
  avatar: string;
}

export interface Title {
  id: string;
  name: string;
  enName: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  duration: string;
  rating: number;
  director: string;
  cast: CastMember[];
  synopsis: string;
  highlights: string[];
  poster: string;
  still: string;
  hot: number;
  tagline: string;
}

const allTitles: Title[] = [
  {
    id: "m-01",
    name: "长夜将尽",
    enName: "When the Long Night Ends",
    type: "movie",
    genres: ["科幻", "悬疑"],
    region: "中国",
    year: 2026,
    duration: "142 分钟",
    rating: 9.1,
    director: "沈砚舟",
    cast: [
      { name: "江晚照", role: "顾南星 / 天轨观测员", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20young%20Chinese%20woman%20astronomer%20in%20a%20dark%20navy%20jacket%2C%20soft%20key%20light%20on%20a%20deep%20muted%20slate%20background%2C%20subtle%20teal%20rim%20light%2C%20editorial%20film%20still%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=300&height=300&seq=cast-jiangwanzhao&orientation=squarish" },
      { name: "陆行知", role: "周砚 / 信号工程师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20thoughtful%20middle-aged%20Chinese%20man%20with%20short%20hair%20wearing%20a%20dark%20coat%2C%20warm%20amber%20side%20light%20against%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=300&height=300&seq=cast-luxingzhi&orientation=squarish" },
      { name: "苏见月", role: "林岚 / 档案员", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20determined%20young%20Chinese%20woman%20with%20tied%20hair%20in%20a%20grey%20knit%20sweater%2C%20cool%20soft%20light%20on%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20subtle%20amber%20accent%2C%20high%20detail&width=300&height=300&seq=cast-sujianyue&orientation=squarish" },
      { name: "韩丘", role: "吴尺 / 站长", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20older%20Chinese%20man%20with%20grey%20temples%20in%20a%20dark%20utility%20uniform%2C%20moody%20low%20key%20lighting%20on%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-hanqiu&orientation=squarish" },
    ],
    synopsis:
      "地表进入第八年极夜，天轨观测站的最后一班观测员顾南星在例行扫描中捕捉到一段不属于人类的回波。她与信号工程师周砚沿着回波一路追查，发现这段信号竟来自三十年前那份被官方封存的档案。当长夜即将结束，他们必须决定：把真相送回地面，还是让它永远留在黑暗里。",
    highlights: [
      "以极夜观测站为舞台的硬科幻设定，光学与声学细节皆有考据",
      "全片 68% 场景采用长镜头调度，营造持续压迫的孤独感",
      "结尾长达九分钟的无声段落被影迷称为年度最佳片段",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20astronomer%20silhouette%20standing%20in%20a%20snowy%20observatory%20dome%20under%20an%20endless%20dark%20aurora%20sky%2C%20deep%20navy%20and%20amber%20accent%20palette%2C%20minimal%20artistic%20style%2C%20high%20contrast%20cinematic%20key%20art%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-longnight&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20dark%20glass%20observatory%20interior%20with%20a%20single%20desk%20lamp%2C%20deep%20navy%20tones%20and%20warm%20amber%20light%2C%20snow%20outside%20the%20panoramic%20window%2C%20moody%20atmospheric%20sci%20fi%20production%20design%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-longnight&orientation=landscape",
    hot: 98,
    tagline: "极夜第八年，有人收到了一封来自过去的信号。",
  },
  {
    id: "m-02",
    name: "雾港来信",
    enName: "Letters from the Fog Harbor",
    type: "movie",
    genres: ["爱情", "文艺"],
    region: "中国",
    year: 2025,
    duration: "118 分钟",
    rating: 8.7,
    director: "何栖",
    cast: [
      { name: "林梢", role: "苏寄 / 邮局职员", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20gentle%20young%20Chinese%20woman%20in%20a%20cream%20cardigan%20holding%20a%20letter%2C%20soft%20overcast%20window%20light%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20delicate%20mood%2C%20high%20detail&width=300&height=300&seq=cast-linshao&orientation=squarish" },
      { name: "温砚白", role: "陈屿 / 船厂画师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20quiet%20young%20Chinese%20man%20with%20slightly%20long%20hair%20in%20a%20linen%20shirt%2C%20cool%20foggy%20light%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-wenyanbai&orientation=squarish" },
      { name: "祝小桐", role: "阿桃 / 隔壁女孩", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20lively%20teenage%20Chinese%20girl%20with%20a%20red%20scarf%2C%20soft%20daylight%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhuxiaotong&orientation=squarish" },
    ],
    synopsis:
      "南方雾港的最后一家老邮局即将关闭。职员苏寄在整理退信时发现一封写于二十年前、从未寄出的信，收信人竟是她自己。她循着信中提到的船厂找到画师陈屿，两人的命运被一封迟到的信慢慢缝合，也揭开了一段被港雾藏起来的旧事。",
    highlights: [
      "全程实景拍摄于福建沿海小镇，雾天光线成为叙事的一部分",
      "配乐使用木质乐器与海风采样，原声带上线即登顶试听榜",
      "以信件为线索的时空结构，被观众称为“最温柔的悬疑片”",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20foggy%20southern%20harbor%20town%20with%20a%20small%20post%20office%2C%20a%20woman%20in%20a%20cream%20coat%20holding%20a%20letter%2C%20muted%20warm%20grey%20and%20amber%20palette%2C%20minimal%20artistic%20style%2C%20soft%20dreamy%20tone%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-fogharbor&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20rainy%20foggy%20harbor%20street%20with%20an%20old%20post%20office%2C%20muted%20warm%20grey%20tones%20with%20amber%20lamplight%2C%20soft%20mist%2C%20delicate%20melancholic%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-fogharbor&orientation=landscape",
    hot: 88,
    tagline: "一封迟了二十年的信，正在找它的收信人。",
  },
  {
    id: "m-03",
    name: "第七码头",
    enName: "Pier Seven",
    type: "movie",
    genres: ["动作", "犯罪"],
    region: "中国香港",
    year: 2024,
    duration: "126 分钟",
    rating: 8.4,
    director: "杜望川",
    cast: [
      { name: "雷震", role: "骆川 / 缉私队长", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20tough%20Chinese%20man%20in%20a%20dark%20leather%20jacket%20with%20a%20fresh%20cut%20on%20his%20brow%2C%20hard%20directional%20light%20on%20a%20black%20green%20background%2C%20editorial%20film%20still%20photography%2C%20gritty%20action%20mood%2C%20high%20detail&width=300&height=300&seq=cast-leizhen&orientation=squarish" },
      { name: "唐茵", role: "何蔓 / 海关稽查", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sharp%20Chinese%20woman%20in%20a%20dark%20uniform%20shirt%2C%20cold%20high%20contrast%20light%20on%20a%20black%20green%20background%2C%20editorial%20film%20still%20photography%2C%20tense%20action%20mood%2C%20high%20detail&width=300&height=300&seq=cast-tangyin&orientation=squarish" },
      { name: "麦子豪", role: "阿鬼 / 走私线人", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20wiry%20young%20Chinese%20man%20with%20a%20hood%20pulled%20back%2C%20green%20neon%20edge%20light%20on%20a%20dark%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-maizihao&orientation=squarish" },
    ],
    synopsis:
      "香港旧货柜码头第七号泊位，一夜之间三艘渔船同时失联。缉私队长骆川在追查中发现，这条航线已经运作了整整十一年，而所有账本的最后签名都指向他自己的名字。九十分钟的追车与码头缠斗之后，他必须在兄弟情义与职业底线之间做出选择。",
    highlights: [
      "全部追车戏采用实拍，动用 27 辆改装车与两艘快艇",
      "港岛夜景与霓虹雨幕构成浓烈视觉风格",
      "动作设计强调重量感，被媒体称为近年最“疼”的港片",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20of%20a%20lone%20man%20in%20a%20leather%20jacket%20standing%20on%20a%20rainy%20container%20pier%20at%20night%2C%20deep%20teal%20and%20amber%20neon%20palette%2C%20minimal%20bold%20style%2C%20high%20contrast%20key%20art%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-pierseven&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20rainy%20container%20pier%20at%20night%20with%20stacked%20containers%2C%20teal%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20two%20figures%20in%20a%20standoff%2C%20gritty%20action%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-pierseven&orientation=landscape",
    hot: 93,
    tagline: "整条航线，都在等他签字。",
  },
  {
    id: "m-04",
    name: "星尘列车",
    enName: "The Stardust Line",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2026,
    duration: "151 分钟",
    rating: 8.9,
    director: "Elias Voss",
    cast: [
      { name: "玛拉·基恩", role: "Iris Vale / 列车长", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20western%20woman%20with%20short%20auburn%20hair%20in%20a%20structured%20dark%20navy%20uniform%2C%20cool%20silver%20rim%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20sci%20fi%20mood%2C%20high%20detail&width=300&height=300&seq=cast-marakeane&orientation=squarish" },
      { name: "托马斯·贝尔", role: "Dr. Orin / 天体物理学家", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20western%20older%20man%20with%20round%20glasses%20and%20a%20grey%20beard%2C%20warm%20amber%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-thomasbell&orientation=squarish" },
      { name: "露西·安", role: "Kaya / 机械师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20mixed%20race%20woman%20with%20braided%20hair%20in%20a%20utility%20jumpsuit%2C%20teal%20ambient%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-lucianne&orientation=squarish" },
    ],
    synopsis:
      "一列横贯银河的观光列车在途经小行星带时偏离航线，乘客发现车厢外的星空正在倒退。列车长 Iris 与天体物理学家 Orin 沿着废弃的车厢一节节往回走，试图找回列车真正的目的地——以及为什么车上每个人都被预订了一张单程票。",
    highlights: [
      "IMAX 实拍与虚拟制片结合，车厢窗外星空为实时渲染",
      "一节车厢一种视觉主题，美术设计被誉为“银河博物馆”",
      "配乐由 92 人交响乐团与合成器共同完成",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20retro%20futuristic%20train%20carriage%20traveling%20through%20a%20purple%20free%20star%20field%2C%20silhouette%20of%20a%20conductor%20at%20the%20window%2C%20deep%20navy%20and%20amber%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-stardustline&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20luxurious%20retro%20futuristic%20train%20carriage%20interior%20with%20a%20panoramic%20window%20showing%20distant%20stars%2C%20deep%20navy%20and%20amber%20lighting%2C%20elegant%20production%20design%2C%20atmospheric%20sci%20fi%20mood%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-stardustline&orientation=landscape",
    hot: 96,
    tagline: "这趟列车没有终点站，只有返程票。",
  },
  {
    id: "m-05",
    name: "夏日回声",
    enName: "Echoes of Summer",
    type: "movie",
    genres: ["青春", "爱情"],
    region: "日韩",
    year: 2025,
    duration: "112 分钟",
    rating: 8.3,
    director: "森川遥",
    cast: [
      { name: "白石凛", role: "夏川葵 / 吹奏部", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20japanese%20teenage%20girl%20with%20a%20short%20bob%20and%20a%20white%20summer%20shirt%2C%20bright%20soft%20sunlight%20on%20a%20pale%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20nostalgic%20summer%20mood%2C%20high%20detail&width=300&height=300&seq=cast-shiraishirin&orientation=squarish" },
      { name: "桐谷央", role: "森野透 / 录音社", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20japanese%20teenage%20boy%20in%20a%20loose%20white%20t%20shirt%20holding%20a%20small%20recorder%2C%20warm%20afternoon%20light%20on%20a%20pale%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20nostalgic%20summer%20mood%2C%20high%20detail&width=300&height=300&seq=cast-kiritaniyou&orientation=squarish" },
    ],
    synopsis:
      "海边小镇的吹奏部即将解散，葵决定在最后一场夏日祭上完成一次演出。录音社的透替她记录下每天的练习声，却意外录到一段十年前的同一天、同一条街的声音。两个人循着这些回声，重新听见了那个夏天没说出口的话。",
    highlights: [
      "以环境音设计贯穿全片，40 分钟对白极少的“声音叙事”",
      "全片于濑户内海实景拍摄，色彩清爽通透",
      "主题曲连续八周占据 Oricon 榜单前十",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20coming%20of%20age%20movie%20poster%20of%20two%20japanese%20teenagers%20on%20a%20seaside%20street%20at%20golden%20hour%20with%20a%20brass%20instrument%2C%20fresh%20pale%20sky%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20nostalgic%20summer%20tone%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-summerecho&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20japanese%20seaside%20town%20street%20at%20golden%20hour%20with%20power%20lines%2C%20two%20teenagers%20walking%20with%20a%20brass%20instrument%20case%2C%20pale%20fresh%20sky%2C%20nostalgic%20summer%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-summerecho&orientation=landscape",
    hot: 79,
    tagline: "有些声音，十年后才会被听见。",
  },
  {
    id: "m-06",
    name: "荒原骑士",
    enName: "Knight of the Wasteland",
    type: "movie",
    genres: ["动作", "冒险"],
    region: "欧美",
    year: 2024,
    duration: "137 分钟",
    rating: 8.1,
    director: "Marcus Hale",
    cast: [
      { name: "伊万·罗", role: "Kade / 游侠", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20weather%20beaten%20western%20man%20with%20a%20scarf%20over%20a%20dust%20coat%2C%20harsh%20desert%20sun%20light%20on%20an%20ochre%20muted%20background%2C%20editorial%20film%20still%20photography%2C%20epic%20adventure%20mood%2C%20high%20detail&width=300&height=300&seq=cast-ivanrowe&orientation=squarish" },
      { name: "妮娜·科尔", role: "Sable / 寻路者", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20determined%20western%20woman%20with%20sun%20bleached%20hair%20and%20dust%20on%20her%20cheek%2C%20harsh%20desert%20sun%20light%20on%20an%20ochre%20muted%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-ninacole&orientation=squarish" },
    ],
    synopsis:
      "沙暴吞没绿洲后的第七年，最后的水源掌握在一支车队手上。游侠 Kade 接下一桩护送任务，护送对象却是一台承载着旧世界地图的机器。穿越三千公里荒原的旅程中，他逐渐明白，这趟任务真正的终点不是地图上的坐标，而是所有人愿意相信的明天。",
    highlights: [
      "沙漠实景拍摄 76 天，动用 200 名群众演员还原废土聚落",
      "手绘概念设计与实景美术高度统一，视觉体系完整",
      "追车与沙暴长镜头为年度最佳动作场面候选",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20lone%20rider%20silhouette%20on%20a%20dusty%20wasteland%20road%20under%20a%20huge%20ochre%20sky%2C%20sandstorm%20in%20the%20distance%2C%20muted%20ochre%20and%20deep%20navy%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-wasteland&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20dusty%20wasteland%20road%20with%20a%20convoy%20of%20weathered%20vehicles%2C%20ochre%20and%20muted%20amber%20tones%2C%20huge%20sky%20with%20dust%20clouds%2C%20epic%20adventure%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-wasteland&orientation=landscape",
    hot: 85,
    tagline: "三千公里荒原，只为一张旧地图。",
  },
  {
    id: "m-07",
    name: "午夜食堂·终章",
    enName: "Midnight Diner: Final Course",
    type: "movie",
    genres: ["剧情", "治愈"],
    region: "日韩",
    year: 2025,
    duration: "124 分钟",
    rating: 8.8,
    director: "小林原",
    cast: [
      { name: "高木修", role: "老板 / 厨师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20japanese%20middle%20aged%20man%20with%20a%20short%20beard%20in%20a%20chef%20apron%2C%20warm%20lantern%20light%20on%20a%20muted%20brown%20background%2C%20editorial%20film%20still%20photography%2C%20warm%20intimate%20mood%2C%20high%20detail&width=300&height=300&seq=cast-takakiosamu&orientation=squarish" },
      { name: "大野樱", role: "美代 / 常客", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20quiet%20japanese%20woman%20in%20her%20thirties%20in%20a%20muted%20green%20coat%2C%20warm%20lantern%20light%20on%20a%20muted%20brown%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-onosakura&orientation=squarish" },
    ],
    synopsis:
      "深夜十二点开门的小食堂，迎来了最后一位客人。老板照例做完最后一碗汤，把三十年来没讲完的故事一件件摊在灶台上。也许离别并不是结束，只是有人愿意在下一顿饭之前，好好说一声再见。",
    highlights: [
      "系列收官之作，原班人马全员回归",
      "每道菜都由真实料理人现场制作，拍摄使用自然蒸汽",
      "放映结束后影院设置“一碗汤”彩蛋场",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20warm%20movie%20poster%20of%20a%20tiny%20japanese%20midnight%20diner%20alley%20entrance%20with%20a%20red%20lantern%2C%20steam%20rising%20from%20the%20door%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-midnightdiner&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20tiny%20japanese%20midnight%20diner%20counter%20with%20steaming%20bowls%20and%20warm%20lantern%20light%2C%20deep%20brown%20and%20amber%20tones%2C%20intimate%20warm%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-midnightdiner&orientation=landscape",
    hot: 81,
    tagline: "最后一碗汤，留给最后一位客人。",
  },
  {
    id: "m-08",
    name: "潮汐之上",
    enName: "Above the Tide",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国",
    year: 2023,
    duration: "131 分钟",
    rating: 8.5,
    director: "徐望",
    cast: [
      { name: "赵岑", role: "林海生 / 船工", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sun%20weathered%20chinese%20fisherman%20in%20his%20fifties%20in%20a%20thick%20blue%20sweater%2C%20overcast%20sea%20light%20on%20a%20cool%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhaocen&orientation=squarish" },
      { name: "钟雨桥", role: "林见 / 女儿", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20chinese%20woman%20in%20a%20simple%20grey%20jacket%20with%20sea%20wind%20in%20her%20hair%2C%20overcast%20sea%20light%20on%20a%20cool%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhongyuqiao&orientation=squarish" },
    ],
    synopsis:
      "渔村即将整体搬迁，老船工林海生坚持把修了半辈子的木船拖上岸。女儿林见从城市赶回，想把父亲接走，却发现船底刻着一行自己小时候写的字。两代人的固执与牵挂，在一次涨潮的夜晚终于有了答案。",
    highlights: [
      "以潮汐时间表作为全片叙事节奏的参照",
      "大量非职业演员参与演出，渔村真实质感强烈",
      "获多个电影节最佳编剧与最佳摄影提名",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20old%20wooden%20fishing%20boat%20on%20a%20grey%20tidal%20mudflat%20with%20a%20small%20village%20in%20the%20distance%2C%20cool%20slate%20blue%20and%20soft%20amber%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-abovetide&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20fishing%20village%20tidal%20mudflat%20at%20dawn%20with%20an%20old%20wooden%20boat%2C%20cool%20slate%20blue%20tones%20with%20soft%20amber%20sun%2C%20quiet%20melancholic%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-abovetide&orientation=landscape",
    hot: 74,
    tagline: "潮水退去的时候，船底的字还在。",
  },
  {
    id: "t-01",
    name: "长夜观测站",
    enName: "Observatory of the Long Night",
    type: "tv",
    genres: ["科幻", "悬疑"],
    region: "中国",
    year: 2026,
    duration: "全 12 集 · 单集 52 分钟",
    rating: 9.3,
    director: "沈砚舟",
    cast: [
      { name: "江晚照", role: "顾南星", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20young%20Chinese%20woman%20astronomer%20in%20a%20dark%20navy%20jacket%2C%20soft%20key%20light%20on%20a%20deep%20muted%20slate%20background%2C%20subtle%20teal%20rim%20light%2C%20editorial%20film%20still%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=300&height=300&seq=cast-jiangwanzhao&orientation=squarish" },
      { name: "陆行知", role: "周砚", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20thoughtful%20middle-aged%20Chinese%20man%20with%20short%20hair%20wearing%20a%20dark%20coat%2C%20warm%20amber%20side%20light%20against%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=300&height=300&seq=cast-luxingzhi&orientation=squarish" },
      { name: "苏见月", role: "林岚", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20determined%20young%20Chinese%20woman%20with%20tied%20hair%20in%20a%20grey%20knit%20sweater%2C%20cool%20soft%20light%20on%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20subtle%20amber%20accent%2C%20high%20detail&width=300&height=300&seq=cast-sujianyue&orientation=squarish" },
      { name: "韩丘", role: "吴尺", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20older%20Chinese%20man%20with%20grey%20temples%20in%20a%20dark%20utility%20uniform%2C%20moody%20low%20key%20lighting%20on%20a%20deep%20muted%20slate%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-hanqiu&orientation=squarish" },
    ],
    synopsis:
      "作为电影《长夜将尽》的剧集化延展，《长夜观测站》把镜头拉回极夜来临的第一年。观测站刚刚建成，十二名成员各自带着秘密上岛。每晚十点，天线都会收到一段相同的信号，而每天早上，都有一个人记不起自己昨晚做了什么。",
    highlights: [
      "电影版前传，十二集对应十二个夜晚与十二个秘密",
      "单集片长恒定为 52 分钟，片尾字幕暗藏下一集线索",
      "上线首周登顶平台热度榜，弹幕解析话题阅读量破亿",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20of%20a%20lone%20radio%20antenna%20array%20on%20a%20snowy%20island%20at%20night%20under%20a%20star%20filled%20sky%2C%20deep%20navy%20and%20amber%20palette%2C%20minimal%20artistic%20style%2C%20high%20contrast%20key%20art%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-observatorytv&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20snowy%20research%20island%20with%20antenna%20arrays%20at%20blue%20hour%2C%20deep%20navy%20tones%20with%20warm%20amber%20windows%2C%20atmospheric%20sci%20fi%20mood%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-observatorytv&orientation=landscape",
    hot: 99,
    tagline: "每晚十点，天线都会收到同一段信号。",
  },
  {
    id: "t-02",
    name: "雾城疑云",
    enName: "Mist City Files",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "中国",
    year: 2025,
    duration: "全 16 集 · 单集 45 分钟",
    rating: 8.9,
    director: "孟昭",
    cast: [
      { name: "顾清和", role: "沈默 / 刑警", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20serious%20chinese%20man%20in%20his%20forties%20in%20a%20dark%20trench%20coat%2C%20cold%20foggy%20light%20on%20a%20grey%20green%20background%2C%20editorial%20film%20still%20photography%2C%20noir%20mood%2C%20high%20detail&width=300&height=300&seq=cast-guqinghe&orientation=squarish" },
      { name: "白露", role: "宋一 / 法医", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20precise%20chinese%20woman%20in%20her%20thirties%20with%20short%20hair%20in%20a%20white%20lab%20coat%2C%20cold%20foggy%20light%20on%20a%20grey%20green%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-bailu&orientation=squarish" },
      { name: "陈墨", role: "老丁 / 线人", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20weathered%20chinese%20man%20in%20a%20hooded%20jacket%2C%20cold%20foggy%20green%20light%20on%20a%20dark%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-chenmo&orientation=squarish" },
    ],
    synopsis:
      "连续三十天的浓雾让雾城变成了一个巨大的密室。一桩看似普通的坠楼案，牵出八年前一桩早已结案的旧案。刑警沈默与法医宋一在雾里一寸寸摸排，发现每一个证人提供的记忆都完美吻合，而这种完美本身就是最大的破绽。",
    highlights: [
      "16 集全部发生在雾天，光影设计成为破案线索之一",
      "案件线索与观众可同步推理，官方提供“卷宗”互动页",
      "大结局单集评分 9.4，被誉为近年国产悬疑剧标杆",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%20of%20a%20man%20in%20a%20trench%20coat%20walking%20into%20thick%20fog%20on%20a%20night%20street%2C%20a%20single%20streetlamp%20glow%2C%20deep%20teal%20grey%20and%20amber%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-mistcity&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20foggy%20city%20street%20at%20night%20with%20a%20single%20streetlamp%20and%20a%20distant%20figure%2C%20deep%20teal%20grey%20tones%20with%20warm%20amber%20light%2C%20tense%20noir%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-mistcity&orientation=landscape",
    hot: 92,
    tagline: "所有证词都完美吻合，这才是最大的破绽。",
  },
  {
    id: "t-03",
    name: "山河食记",
    enName: "Taste of the Rivers",
    type: "tv",
    genres: ["剧情", "治愈"],
    region: "中国",
    year: 2025,
    duration: "全 10 集 · 单集 40 分钟",
    rating: 8.6,
    director: "罗青禾",
    cast: [
      { name: "许棠", role: "阿棠 / 厨娘", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20warm%20chinese%20woman%20in%20her%20thirties%20with%20an%20apron%20over%20a%20light%20shirt%2C%20soft%20kitchen%20daylight%20on%20a%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20warm%20gentle%20mood%2C%20high%20detail&width=300&height=300&seq=cast-xutang&orientation=squarish" },
      { name: "伍长川", role: "老伍 / 船夫", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elderly%20chinese%20boatman%20with%20a%20straw%20hat%20on%20his%20back%2C%20soft%20river%20daylight%20on%20a%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-wuchangchuan&orientation=squarish" },
    ],
    synopsis:
      "阿棠在城市开了一家小餐馆，生意冷清。她决定沿着家乡的河流一路向上，把沿途村落的旧菜谱一道道找回来。每一道菜背后都有一个人、一段迁徙和一次告别。十集十道菜，也拼出了一个家庭三十年的地图。",
    highlights: [
      "每集结束附有真实菜谱与人物手写笔记",
      "取材自多条南方水系的民间饮食记录",
      "慢节奏叙事，被称为“可以下饭的纪录片剧”",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20warm%20series%20poster%20of%20a%20small%20riverside%20kitchen%20with%20steaming%20dishes%20and%20a%20woman%20in%20an%20apron%2C%20soft%20cream%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20gentle%20nostalgic%20tone%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-riversfood&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20riverside%20village%20kitchen%20with%20steaming%20woks%20and%20morning%20mist%20over%20the%20river%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20gentle%20nostalgic%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-riversfood&orientation=landscape",
    hot: 76,
    tagline: "十道菜，一条河，一个家的三十年。",
  },
  {
    id: "t-04",
    name: "霓虹事务所",
    enName: "Neon Bureau",
    type: "tv",
    genres: ["悬疑", "科幻"],
    region: "欧美",
    year: 2026,
    duration: "全 8 集 · 单集 55 分钟",
    rating: 8.7,
    director: "Elias Voss",
    cast: [
      { name: "玛拉·基恩", role: "Nora Hale / 探员", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20western%20woman%20with%20short%20auburn%20hair%20in%20a%20structured%20dark%20navy%20uniform%2C%20cool%20silver%20rim%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20sci%20fi%20mood%2C%20high%20detail&width=300&height=300&seq=cast-marakeane&orientation=squarish" },
      { name: "雷蒙·托", role: "Eli / 分析师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20asian%20western%20man%20with%20glasses%20in%20a%20dark%20shirt%2C%20teal%20neon%20edge%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-raymondto&orientation=squarish" },
    ],
    synopsis:
      "在可以随时重写记忆的未来城市，霓虹事务所专门处理“记错了”的案件。探员 Nora 接到一桩奇怪的委托：有人声称自己从未存在过。随着调查深入，她发现自己办公桌上那份档案，也在一点点变薄。",
    highlights: [
      "赛博城市设计由《星尘列车》美术团队操刀",
      "八集对应八个记忆层级，每集色调逐层变冷",
      "每集片尾设置 30 秒“记忆残片”彩蛋",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20series%20poster%20of%20a%20detective%20silhouette%20in%20a%20rainy%20neon%20city%20alley%20with%20glowing%20signs%2C%20deep%20teal%20and%20amber%20neon%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-neonbureau&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20rainy%20futuristic%20city%20alley%20with%20teal%20and%20amber%20neon%20signs%2C%20holographic%20advertisements%2C%20wet%20reflective%20ground%2C%20cyberpunk%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-neonbureau&orientation=landscape",
    hot: 90,
    tagline: "有人声称，自己从未存在过。",
  },
  {
    id: "t-05",
    name: "春日便利店",
    enName: "Spring Convenience",
    type: "tv",
    genres: ["青春", "治愈"],
    region: "日韩",
    year: 2025,
    duration: "全 12 集 · 单集 35 分钟",
    rating: 8.4,
    director: "森川遥",
    cast: [
      { name: "白石凛", role: "小满 / 店员", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20japanese%20teenage%20girl%20with%20a%20short%20bob%20and%20a%20white%20summer%20shirt%2C%20bright%20soft%20sunlight%20on%20a%20pale%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20nostalgic%20summer%20mood%2C%20high%20detail&width=300&height=300&seq=cast-shiraishirin&orientation=squarish" },
      { name: "桐谷央", role: "凉太 / 夜班", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20japanese%20teenage%20boy%20in%20a%20loose%20white%20t%20shirt%20holding%20a%20small%20recorder%2C%20warm%20afternoon%20light%20on%20a%20pale%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20nostalgic%20summer%20mood%2C%20high%20detail&width=300&height=300&seq=cast-kiritaniyou&orientation=squarish" },
    ],
    synopsis:
      "小镇上唯一一家 24 小时便利店，承担着半个镇子的情绪出口。新来的夜班店员小满喜欢把客人的故事写进便签本，直到某天她发现，便签上的字迹会在第二天变成真的。十二集，十二个进店的人，十二种被悄悄治愈的夜晚。",
    highlights: [
      "以固定机位与自然光拍摄，营造真实生活质感",
      "每集一位客串演员，形成“一日一客”话题",
      "衍生短剧与便利店联名活动同步上线",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20heartwarming%20series%20poster%20of%20a%20small%20japanese%20convenience%20store%20glowing%20in%20a%20quiet%20night%20street%20with%20cherry%20blossom%20petals%2C%20soft%20cream%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-springstore&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20quiet%20japanese%20street%20at%20night%20with%20a%20warmly%20lit%20small%20convenience%20store%2C%20soft%20cream%20and%20amber%20tones%2C%20gentle%20nostalgic%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-springstore&orientation=landscape",
    hot: 82,
    tagline: "便签上的字，第二天都会成真。",
  },
  {
    id: "t-06",
    name: "王座与灰烬",
    enName: "Thrones of Ash",
    type: "tv",
    genres: ["奇幻", "剧情"],
    region: "欧美",
    year: 2024,
    duration: "全 10 集 · 单集 60 分钟",
    rating: 8.8,
    director: "Marcus Hale",
    cast: [
      { name: "妮娜·科尔", role: "Isolde / 北境之主", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20determined%20western%20woman%20with%20sun%20bleached%20hair%20and%20dust%20on%20her%20cheek%2C%20harsh%20desert%20sun%20light%20on%20an%20ochre%20muted%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-ninacole&orientation=squarish" },
      { name: "伊万·罗", role: "Kade / 铁匠之子", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20weather%20beaten%20western%20man%20with%20a%20scarf%20over%20a%20dust%20coat%2C%20harsh%20desert%20sun%20light%20on%20an%20ochre%20muted%20background%2C%20editorial%20film%20still%20photography%2C%20epic%20adventure%20mood%2C%20high%20detail&width=300&height=300&seq=cast-ivanrowe&orientation=squarish" },
      { name: "托马斯·贝尔", role: "Master Orin", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20western%20older%20man%20with%20round%20glasses%20and%20a%20grey%20beard%2C%20warm%20amber%20light%20on%20a%20deep%20charcoal%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-thomasbell&orientation=squarish" },
    ],
    synopsis:
      "旧王朝在灰烬中覆灭，三个继承者各自握着一半真相。北境之主 Isolde 想用战争结束战争，铁匠之子 Kade 却相信还有另一种办法。当最后的王座被重新铸起，坐上它的人必须先承认自己烧掉了什么。",
    highlights: [
      "单集制作成本创下剧集纪录，实景搭建三座城池",
      "群像塑造复杂，没有绝对的反派",
      "服装设计获国际设计大奖提名",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20fantasy%20series%20poster%20of%20a%20ruined%20stone%20throne%20surrounded%20by%20embers%20and%20smoke%2C%20lone%20cloaked%20figure%20approaching%2C%20deep%20charcoal%20and%20warm%20amber%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-thronesash&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20ruined%20stone%20hall%20with%20embers%20floating%20in%20the%20air%20and%20a%20cloaked%20ruler%20on%20a%20broken%20throne%2C%20deep%20charcoal%20and%20warm%20amber%20tones%2C%20epic%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-thronesash&orientation=landscape",
    hot: 87,
    tagline: "坐上王座之前，先承认自己烧掉了什么。",
  },
  {
    id: "t-07",
    name: "海雾之下",
    enName: "Beneath the Sea Fog",
    type: "tv",
    genres: ["悬疑", "剧情"],
    region: "中国",
    year: 2026,
    duration: "全 14 集 · 单集 48 分钟",
    rating: 9.0,
    director: "孟昭",
    cast: [
      { name: "顾清和", role: "陈渡 / 海警", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20serious%20chinese%20man%20in%20his%20forties%20in%20a%20dark%20trench%20coat%2C%20cold%20foggy%20light%20on%20a%20grey%20green%20background%2C%20editorial%20film%20still%20photography%2C%20noir%20mood%2C%20high%20detail&width=300&height=300&seq=cast-guqinghe&orientation=squarish" },
      { name: "林梢", role: "苏寄 / 记者", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20gentle%20young%20Chinese%20woman%20in%20a%20cream%20cardigan%20holding%20a%20letter%2C%20soft%20overcast%20window%20light%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20delicate%20mood%2C%20high%20detail&width=300&height=300&seq=cast-linshao&orientation=squarish" },
      { name: "雷震", role: "骆九 / 老船长", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20tough%20Chinese%20man%20in%20a%20dark%20leather%20jacket%20with%20a%20fresh%20cut%20on%20his%20brow%2C%20hard%20directional%20light%20on%20a%20black%20green%20background%2C%20editorial%20film%20still%20photography%2C%20gritty%20action%20mood%2C%20high%20detail&width=300&height=300&seq=cast-leizhen&orientation=squarish" },
    ],
    synopsis:
      "海雾季到来，一艘渔船在雷达上消失了整整四十分钟。海警陈渡与记者苏寄联手调查，发现这片海域过去二十年里共有十一条船只在雾中“失踪”。当雾散去，海面下露出的不只是残骸，还有一整代人默契守口如瓶的往事。",
    highlights: [
      "海雾实景与水下摄影交织，形成独特视觉语言",
      "案件结构与社会议题并行，被赞“最有重量的国产悬疑”",
      "全网评分 9.0，成为年度口碑剧集",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%20of%20a%20small%20fishing%20boat%20emerging%20from%20thick%20sea%20fog%20at%20dawn%2C%20deep%20slate%20blue%20and%20soft%20amber%20palette%2C%20minimal%20artistic%20style%2C%20isolated%20mood%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-seafog&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20fishing%20boat%20in%20thick%20sea%20fog%20with%20faint%20warm%20lantern%20light%2C%20deep%20slate%20blue%20tones%2C%20mysterious%20atmospheric%20mood%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-seafog&orientation=landscape",
    hot: 95,
    tagline: "雾散之后，海面下还有一整代人没说出口的事。",
  },
  {
    id: "t-08",
    name: "灯火人家",
    enName: "Lights in Every Home",
    type: "tv",
    genres: ["家庭", "剧情"],
    region: "中国",
    year: 2023,
    duration: "全 36 集 · 单集 45 分钟",
    rating: 8.2,
    director: "徐望",
    cast: [
      { name: "赵岑", role: "林建国 / 父亲", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sun%20weathered%20chinese%20fisherman%20in%20his%20fifties%20in%20a%20thick%20blue%20sweater%2C%20overcast%20sea%20light%20on%20a%20cool%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhaocen&orientation=squarish" },
      { name: "钟雨桥", role: "林见 / 长女", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20chinese%20woman%20in%20a%20simple%20grey%20jacket%20with%20sea%20wind%20in%20her%20hair%2C%20overcast%20sea%20light%20on%20a%20cool%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhongyuqiao&orientation=squarish" },
      { name: "许棠", role: "林照 / 次女", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20warm%20chinese%20woman%20in%20her%20thirties%20with%20an%20apron%20over%20a%20light%20shirt%2C%20soft%20kitchen%20daylight%20on%20a%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20warm%20gentle%20mood%2C%20high%20detail&width=300&height=300&seq=cast-xutang&orientation=squarish" },
    ],
    synopsis:
      "老城区改造的三年里，林家的三层小楼被夹在新楼之间。父亲不愿搬走，两个女儿各有各的难处，邻居们也在等一个说法。三十六集，讲的是一栋房子，也是一座城市如何和过去握手。",
    highlights: [
      "生活流叙事，日常细节密度极高",
      "老城区实景拍摄，拆迁前的街道被完整记录",
      "面向全年龄观众，家庭共看率居高",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20family%20series%20poster%20of%20an%20old%20chinese%20residential%20building%20with%20warmly%20lit%20windows%20at%20dusk%20and%20laundry%20lines%2C%20soft%20cream%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-lightsHome&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20an%20old%20chinese%20neighborhood%20alley%20at%20dusk%20with%20warm%20lit%20windows%20and%20bicycles%20parked%2C%20soft%20cream%20and%20amber%20tones%2C%20nostalgic%20daily%20life%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-lightsHome&orientation=landscape",
    hot: 71,
    tagline: "一栋房子，装着三代人的灯。",
  },
  {
    id: "m-09",
    name: "雨天不打烊",
    enName: "Open on Rainy Days",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "中国",
    year: 2024,
    duration: "107 分钟",
    rating: 7.9,
    director: "何栖",
    cast: [
      { name: "温砚白", role: "季安 / 唱片店老板", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20quiet%20young%20Chinese%20man%20with%20slightly%20long%20hair%20in%20a%20linen%20shirt%2C%20cool%20foggy%20light%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-wenyanbai&orientation=squarish" },
      { name: "祝小桐", role: "小于 / 插画师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20lively%20teenage%20Chinese%20girl%20with%20a%20red%20scarf%2C%20soft%20daylight%20on%20a%20muted%20warm%20grey%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-zhuxiaotong&orientation=squarish" },
    ],
    synopsis:
      "唱片店只在雨天营业，老板季安说这样人少，唱针不会被打扰。插画师小于连续七个雨天都来买同一张唱片，直到有一天她终于承认，自己其实是在等一个人把第八张放上去。",
    highlights: [
      "全片雨景实拍，共记录 41 场真实降雨",
      "配乐以黑胶唱片质感为核心，收录 12 首原创曲",
      "小成本制作，凭口碑完成长线放映",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20movie%20poster%20of%20a%20small%20record%20store%20window%20with%20rain%20streaks%20and%20warm%20interior%20light%2C%20vinyl%20records%20on%20display%2C%20muted%20grey%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-openrainy&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20cozy%20small%20record%20store%20interior%20with%20rain%20on%20the%20window%2C%20vinyl%20shelves%20and%20warm%20amber%20lamplight%2C%20muted%20grey%20tones%2C%20intimate%20melancholic%20mood%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-openrainy&orientation=landscape",
    hot: 68,
    tagline: "只在雨天开门，只等一个人来。",
  },
  {
    id: "t-09",
    name: "风起茶山",
    enName: "Wind Over the Tea Hills",
    type: "tv",
    genres: ["剧情", "家庭"],
    region: "中国",
    year: 2024,
    duration: "全 20 集 · 单集 42 分钟",
    rating: 8.0,
    director: "罗青禾",
    cast: [
      { name: "许棠", role: "茶禾 / 制茶师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20warm%20chinese%20woman%20in%20her%20thirties%20with%20an%20apron%20over%20a%20light%20shirt%2C%20soft%20kitchen%20daylight%20on%20a%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20warm%20gentle%20mood%2C%20high%20detail&width=300&height=300&seq=cast-xutang&orientation=squarish" },
      { name: "伍长川", role: "老茶农", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elderly%20chinese%20boatman%20with%20a%20straw%20hat%20on%20his%20back%2C%20soft%20river%20daylight%20on%20a%20cream%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-wuchangchuan&orientation=squarish" },
    ],
    synopsis:
      "茶山合作社的年轻制茶师茶禾决定恢复一款失传的老茶。她带着父亲留下的半本笔记走遍山场，却发现父亲当年并没有写完那本笔记——剩下的部分，藏在每一户人家的茶罐里。",
    highlights: [
      "全剧在茶山实景拍摄，四季变化逐集呈现",
      "炒茶工艺由非遗传承人现场指导",
      "剧集与茶产地文旅合作，带动当地茶旅",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20of%20layered%20green%20tea%20terraces%20in%20morning%20mist%20with%20a%20small%20figure%20carrying%20a%20basket%2C%20fresh%20green%20and%20warm%20amber%20palette%2C%20minimal%20artistic%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-teahills&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20layered%20green%20tea%20terraces%20in%20morning%20mist%20with%20a%20small%20house%2C%20fresh%20green%20and%20warm%20amber%20tones%2C%20calm%20rural%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-teahills&orientation=landscape",
    hot: 66,
    tagline: "剩下的半本笔记，藏在每家茶罐里。",
  },
  {
    id: "m-10",
    name: "沉默证词",
    enName: "Silent Testimony",
    type: "movie",
    genres: ["悬疑", "剧情"],
    region: "中国香港",
    year: 2026,
    duration: "119 分钟",
    rating: 8.6,
    director: "杜望川",
    cast: [
      { name: "唐茵", role: "方宁 / 律师", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sharp%20Chinese%20woman%20in%20a%20dark%20uniform%20shirt%2C%20cold%20high%20contrast%20light%20on%20a%20black%20green%20background%2C%20editorial%20film%20still%20photography%2C%20tense%20action%20mood%2C%20high%20detail&width=300&height=300&seq=cast-tangyin&orientation=squarish" },
      { name: "麦子豪", role: "阿树 / 证人", avatar: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20wiry%20young%20Chinese%20man%20with%20a%20hood%20pulled%20back%2C%20green%20neon%20edge%20light%20on%20a%20dark%20background%2C%20editorial%20film%20still%20photography%2C%20high%20detail&width=300&height=300&seq=cast-maizihao&orientation=squarish" },
    ],
    synopsis:
      "一桩没有物证的旧案在十年后重新开庭。律师方宁接下了所有人都劝她放弃的辩护，唯一的证人是当年只有九岁、如今却拒绝开口的男孩阿树。她必须在法庭之外，先让一个人重新相信说话的意义。",
    highlights: [
      "全片 60% 场景发生在法庭与审讯室",
      "以声音设计表现沉默，几乎没有背景音乐",
      "上映后引发对证人保护制度的广泛讨论",
    ],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20courtroom%20drama%20movie%20poster%20of%20a%20woman%20lawyer%20silhouette%20in%20a%20dark%20corridor%20with%20a%20barred%20window%20casting%20light%2C%20deep%20charcoal%20and%20pale%20amber%20palette%2C%20minimal%20bold%20style%2C%20vertical%20composition%2C%20film%20grain&width=800&height=1200&seq=poster-silenttestimony&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20an%20empty%20hong%20kong%20courtroom%20with%20afternoon%20light%20through%20tall%20windows%2C%20deep%20charcoal%20and%20pale%20amber%20tones%2C%20tense%20quiet%20atmosphere%2C%20subtle%20film%20grain&width=1600&height=900&seq=still-silenttestimony&orientation=landscape",
    hot: 89,
    tagline: "唯一愿意作证的人，已经十年没有开口。",
  },
];

export const titles = allTitles;

export const movieCount = allTitles.filter((item) => item.type === "movie").length;
export const tvCount = allTitles.filter((item) => item.type === "tv").length;

export const genreOptions = ["全部题材", "科幻", "悬疑", "动作", "爱情", "剧情", "青春", "家庭", "犯罪", "冒险", "奇幻", "治愈", "文艺"];
export const regionOptions = ["全部地区", "中国", "中国香港", "欧美", "日韩"];
export const yearOptions = ["全部年份", "2026", "2025", "2024", "2023", "2022及更早"];
export const sortOptions = [
  { value: "hot", label: "热门优先" },
  { value: "new", label: "最新上线" },
  { value: "rating", label: "评分最高" },
] as const;

export type SortValue = (typeof sortOptions)[number]["value"];

export function getTitleById(id: string | undefined): Title | undefined {
  return allTitles.find((item) => item.id === id);
}

export function getRelatedTitles(current: Title, limit = 4): Title[] {
  const scored = allTitles
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.director === current.director) score += 3;
      score += item.genres.filter((g) => current.genres.includes(g)).length * 2;
      if (item.region === current.region) score += 1;
      if (item.type === current.type) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export const featuredIds = ["t-01", "m-01", "m-04", "t-07"];

export function getFeaturedTitles(): Title[] {
  return featuredIds
    .map((id) => getTitleById(id))
    .filter((item): item is Title => Boolean(item));
}